export default __webpack_public_path__ + "static/media/login.65b77ad8.svg";